var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRenew(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#9297A2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8 4v1.193c0 .3.36.447.567.234l1.86-1.86c.133-.134.133-.34 0-.474l-1.86-1.86C8.36 1.027 8 1.173 8 1.473v1.194C5.053 2.667 2.667 5.053 2.667 8c0 .693.133 1.36.38 1.967.18.446.753.566 1.093.226.18-.18.253-.453.153-.693C4.1 9.04 4 8.527 4 8c0-2.207 1.793-4 4-4zm3.86 1.807c-.18.18-.253.46-.153.693.186.467.293.973.293 1.5 0 2.207-1.793 4-4 4v-1.193c0-.3-.36-.447-.567-.234l-1.86 1.86c-.133.134-.133.34 0 .474l1.86 1.86c.207.206.567.06.567-.234v-1.2c2.947 0 5.333-2.386 5.333-5.333 0-.693-.133-1.36-.38-1.967-.18-.446-.753-.566-1.093-.226z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRenew);
export default __webpack_public_path__ + "static/media/renew.81f747260e63648bc9fc9f5f72c6e9e7.svg";
export { ForwardRef as ReactComponent };